import { Icon } from '@cinch/ui';
import React, { useContext } from 'react';
import { Scoped } from 'kremling';
import styles from './media.styles.scss';
import { UserStateContext } from 'context/user-state-context';
import { rule } from 'postcss';
function authentication_url(url, token) {
  if (url.startsWith("https://s3.")) {
    // bandwidth put's the images directly in S3, so we can just return the url without signing it
    return url;
  } else {
    return API_URL + "/communication/sms/twilio-download?url=" + encodeURIComponent(url) + "&_token=" + encodeURIComponent(token);
  }
}
export function Media(props) {
  const {
    token
  } = useContext(UserStateContext);
  let content;
  if (['image/bmp', 'image/gif', 'image/jpeg', 'image/png'].includes(props.media.content_type)) {
    content = <img src={authentication_url(props.media.url, token)} style={{
      width: "100%"
    }} />;
  } else {
    content = <div>
      <Icon size={30} name="fa-regular-file" />
    </div>;
  }
  return <Scoped css={styles}>
      <a href={authentication_url(props.media.url, token)} target="_blank">
        {content}
      </a>
    </Scoped>;
}